// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7QzNA","left":"styles_left__1Efkb"};